module.exports = __webpack_public_path__ + "img/kavalan.7ee9809a.jpg";